import React from 'react'
import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { colors, measurements } from '@mobi/component-library/Foundations'

type Props = {
  children: React.ReactNode
  background?: 'white' | 'grey' | 'surface50' | 'surface300'
  style?: React.CSSProperties
  testId?: string
}

export const MainContainer = React.forwardRef<HTMLDivElement, Props>(
  ({ children, background, style, testId }, ref) => (
    <MainContainerStyled ref={ref} style={style} data-testid={testId} data-background={background}>
      {children}
    </MainContainerStyled>
  )
)

MainContainer.displayName = 'MainContainer'

// ======
// Styles
// ======

const MainContainerStyled = styled.section({
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  margin: '0 auto',
  minHeight: `calc(100vh - ${measurements.mobi.bottomTabsHeight} - ${measurements.mobi.headerHeight})`,
  minWidth: measurements.mobi.minWidth,
  maxWidth: measurements.mobi.maxWidth,

  '@supports (min-height: 100dvh)': {
    minHeight: `calc(100dvh - ${measurements.mobi.bottomTabsHeight} - ${measurements.mobi.headerHeight})`,
  },

  '&[data-background="white"]': { backgroundColor: colors.white },
  '&[data-background="grey"]': { backgroundColor: hexColors.gainsboro },
  '&[data-background="surface50"]': { backgroundColor: colors.surface[50] },
  '&[data-background="surface300"]': { backgroundColor: colors.surface[300] },
})
